import React from "react";
import useFetch from "../../hooks/useFetch";
import LoadingCard from "../../elements/LoadingCard";
import EspCard from "./EspCard";
import EspErrorCard from "./EspErrorCard";

export default function PharmaciesWithPricingAccess() {
  const { isLoading, data, error } = useFetch("pharmacies-with-pricing-access");

  if (isLoading) return <LoadingCard />;

  if (error) {
    return (
      <EspErrorCard error={error}>
        <EspErrorCard.Copy />
      </EspErrorCard>
    );
  }

  return (
    <EspCard data={data} tag={<EspCard.NumberTag />}>
      <EspCard.Section>
        <EspCard.Copy>
          <EspCard.FeaturedDataPoint /> Distinct CPs currently have access to 340B pricing.
        </EspCard.Copy>
        <EspCard.Interval />
      </EspCard.Section>
    </EspCard>
  );
}
